import { render, staticRenderFns } from "./ListOrderNumber.vue?vue&type=template&id=28e57512&scoped=true"
import script from "./ListOrderNumber.vue?vue&type=script&lang=js"
export * from "./ListOrderNumber.vue?vue&type=script&lang=js"
import style0 from "./ListOrderNumber.vue?vue&type=style&index=0&id=28e57512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e57512",
  null
  
)

export default component.exports